
// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, createPromotionForProfessional } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitSavePromotionProfessionalAPi = createAsyncThunk("hitSavePromotionProfessionalAPi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("professionalToken")}`,
      },
    };
    const url = ApiBaseUrl + createPromotionForProfessional;
    const response = await axios.post(url, payload, config);
    return response.data;
  } catch (error) {
    showToast(error.response.data.message, "error");
    throw error.response.data;
  }
});

const SavePromotionSlice = createSlice({
  name: "savePromotionReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitSavePromotionData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitSavePromotionProfessionalAPi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitSavePromotionProfessionalAPi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitSavePromotionProfessionalAPi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitSavePromotionData } = SavePromotionSlice.actions;
export default SavePromotionSlice.reducer;
